module.exports = __webpack_public_path__ + "static/media/challenge.aee94440.png";